/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Autocomplete, AutocompleteRenderInputParams, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';
import { VIEW_MODE } from '../../../../consts/enums';
import CustomTextField from '../../../../components/CustomTextField';
import { NoCompanies } from './NoCompanies';
import { style } from './style';

type AutocompleteCompanyProps = {
  listAutocomplete:Company[],
  onInputValueChange: (event:React.SyntheticEvent, newInputValue:string) => void,
  onOptionSelected: (event:React.SyntheticEvent, newInputValue: Company | null) => void,
  onChangeValues: (event:React.SyntheticEvent, newInputValue:string) => void,
  valueName: string,
  id: string,
  label: string,
  disabled?: boolean,
  isLoading?: boolean,
  viewMode: ViewMode,
  companiesGetFrom: string,
  onOpenCreateNewCompanyModal?: (id:string) => void,
}
const AutocompleteCompany = ({
  listAutocomplete,
  onInputValueChange,
  onOptionSelected,
  valueName,
  label,
  onChangeValues,
  isLoading,
  viewMode,
  companiesGetFrom,
  id,
  onOpenCreateNewCompanyModal,
}: AutocompleteCompanyProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: Company) => {
    return (
      <Box
        component="li"
        { ...props }
        sx={ { '& > img': { mr: 2, flexShrink: 0 } } }
        key={ option.id }
      >
        <img
          loading="lazy"
          style={ style.image }
          src={ option.logo }
          alt=""
        />
        {option.name}
      </Box>
    );
  };

  const renderInput = (params: AutocompleteRenderInputParams) => (
    <CustomTextField
      viewMode={ viewMode }
      { ...params }
      label={ label }
      inputProps={ {
        ...params.inputProps,
      } }
      onChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
        onInputValueChange(e, e.target.value);
        onChangeValues(e, e.target.value);
      } }
    />
  );

  const getOptionLabel = (option: Company) => valueName || option.name;

  return (
    <Autocomplete
      loading={ isLoading }
      loadingText={ translate(STRING_KEYS.SEARCHING) }
      fullWidth
      noOptionsText={ (
        <NoCompanies
          companiesGetFrom={ companiesGetFrom }
          onOpenCreateNewCompanyModal={ () => {
            if (onOpenCreateNewCompanyModal) {
              onOpenCreateNewCompanyModal(id);
            }
          } }
          valueName={ valueName }
          listAutocomplete={ listAutocomplete }
        />
      ) }
      disabled={ viewMode === VIEW_MODE.READ_ONLY }
      inputValue={ valueName }
      options={ listAutocomplete || [] }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onChange={ onOptionSelected }
      autoHighlight
      getOptionLabel={ getOptionLabel }
      renderOption={ renderOption }
      renderInput={ renderInput }
    />
  );
};

AutocompleteCompany.defaultProps = {
  disabled: false,
  isLoading: false,
  onOpenCreateNewCompanyModal: undefined,
};

export default AutocompleteCompany;
